;(function() {
  'use strict'

  Controller.$inject = ["$state", "glAnalytics", "channelService", "subscriberService", "userService", "uacService", "externalPanelService", "Channel", "StateFactory"];
  angular.module('app.core').component('channelPicker', {
    controller: Controller,
    templateUrl: 'channel-picker.html',
    bindings: {
      channel: '<',
      onDone: '&',
      onClose: '&',
    },
  })

  /* @ngInject */
  function Controller(
    $state,
    glAnalytics,
    channelService,
    subscriberService,
    userService,
    uacService,
    externalPanelService,
    Channel,
    StateFactory
  ) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.select = select
    ctrl.getTypeName = getTypeName

    function onInit() {
      externalPanelService
        .list()
        .then(setTypes)
        .catch(function(error) {
          console.error(error)
          setTypes([])
        })
      ctrl.state = new StateFactory(['picker', 'places'])
      ctrl.state.picker()
      ctrl.isSSR = userService.isSSR()
      ctrl.accountBillingUrl = $state.href(
        'account',
        { tab: 'billing' },
        { absolute: true }
      )
      if (ctrl.channel.isNew) {
        glAnalytics.track('channel', 'create-new')
      } else {
        glAnalytics.track(
          'channel',
          'view-or-edit',
          ctrl.channel.id + ' - ' + ctrl.channel.name
        )
      }
    }

    function setTypes(panels) {
      var subscriber = subscriberService.getSubscriber()
      var isSSR = userService.isSSR()
      ctrl.types = channelService.getTypes().filter(function(type) {
        // hide integrated panel if disabled in admin tab
        if (
          type.value === Channel.Type.PANEL &&
          !subscriber.data.allowAddIntegratedPanel
        ) {
          return false
        }

        // hide third-party panel if the user has no panel partner to pick
        if (
          type.value === Channel.Type.EXTERNAL_PANEL &&
          !_.some(panels, uacService.canPickPanelPartner)
        ) {
          return false
        }

        return true
      })
      ctrl.primaryTypes = ctrl.types.filter(function(type) {
        return type.category === Channel.Category.PRIMARY
      })
      ctrl.otherTypes = ctrl.types.filter(function(type) {
        // return other category type
        // and hide "Your Crowd" channel type
        return (
          type.category === Channel.Category.OTHER && type.value !== 'CROWD'
        )
      })
      ctrl.premiumTypes = ctrl.types.filter(function(type) {
        return type.category === Channel.Category.PREMIUM
      })
    }

    function select(type) {
      if (type === 'CROWD') return // coming soon
      ctrl.channel.setType(type)
      glAnalytics.track('channel', 'select-type', type)
      switch (type) {
        case ctrl.channel.Type.CUSTOM:
        case ctrl.channel.Type.KIOSK:
        case ctrl.channel.Type.PRODUCTS:
        case ctrl.channel.Type.EXTERNAL_PANEL:
        case ctrl.channel.Type.PANEL:
          ctrl.onDone({ $channel: ctrl.channel })
          break
        case ctrl.channel.Type.PLACES:
          if (ctrl.isSSR) {
            ctrl.onDone({ $channel: ctrl.channel })
          } else {
            ctrl.state.places()
          }
          break
        default:
        // ...
      }
    }

    function getTypeName() {
      return _.find(ctrl.types, { value: ctrl.channel.type }).name
    }
  }
})()
